import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import {
  SelectionsLimitationType,
  FieldSettings,
  TextObject,
} from "@/shared/types";
import AlertCircleIcon from "@/shared/icons/AlertCircleIcon";
import styles from "./CheckboxInput.module.scss";

interface CheckboxInputProps {
  registerProps?: UseFormRegisterReturn;
  isError?: boolean;
  fieldSettings: FieldSettings;
  selectedOptions: string[];
  text: TextObject;
}
const CheckboxInput: React.FC<CheckboxInputProps> = ({
  registerProps,
  isError,
  fieldSettings,
  selectedOptions,
  text,
}) => {
  const isLimited =
    fieldSettings?.selections?.type === SelectionsLimitationType.Limited;
  const isMulti = fieldSettings?.isMultipleSelection;
  const maxSelect = fieldSettings?.selections?.selectionsCount;
  const selectionsCount = selectedOptions?.length || 0;

  return (
    <div className={styles.checkboxWrapper}>
      {fieldSettings?.options?.map((option) => {
        const isSelected = selectedOptions
          ? selectedOptions?.includes(option?.id)
          : false;

        const disabled = isMulti
          ? isLimited && !isSelected && selectionsCount === maxSelect
          : !isSelected && selectionsCount > 0;

        return (
          <div key={option?.id} className={styles.checkboxInput}>
            <input
              id={option?.id}
              value={option?.id}
              type="checkbox"
              {...registerProps}
              disabled={disabled}
            />
            <label
              htmlFor={option?.id}
              id="general-text"
              style={{ cursor: "pointer" }}
              className="general-input-label"
            >
              {text[option?.label?.textId!]}
            </label>
          </div>
        );
      })}
      {isError && <AlertCircleIcon />}
    </div>
  );
};

export default CheckboxInput;
